module.exports = __webpack_public_path__ + "img/json-uploader.48c121df.png";